import { Alert } from "./Alert";
export const SuccessAlert = ( { successMessage } ) => (
	<Alert message={successMessage} type="success"/>
);
